<script setup lang="ts">
import {useTemplateRef} from "vue";

const map = useTemplateRef("map-overlay")
const closeMapPopup = () => {
  map.value.classList.add("hidden");
}


</script>

<template>

  <div id="map-overlay" ref="map-overlay" class="map-popup-overlay hidden" @click="closeMapPopup">
    <div id="map-overlay-map" class="map-popup-map relative" @click.stop>
      <button
          class="absolute top-6 right-5 z-50 bg-white p-3 rounded-full shadow-lg flex items-center justify-center hover:bg-gray-200 transition-all duration-300"
          @click="closeMapPopup"
      >
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="" class="w-5 h-5">
      </button>
    </div>
  </div>
</template>